import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20studio%20with%20curated%20fashion%20items%20floating%20in%20artistic%20arrangement%2C%20soft%20diffused%20overhead%20lighting%20creating%20gentle%20shadows%20on%20cream%20linen%20backdrop%2C%20warm%20champagne%20and%20sand%20tones%2C%20luxury%20editorial%20aesthetic%2C%20abstract%20geometric%20composition%20with%20clothing%20pieces%20and%20accessories%20suspended%20in%20harmonious%20balance%2C%20sophisticated%20high%20fashion%20catalog%20atmosphere%2C%20clean%20refined%20modern%20art%20direction&width=1920&height=1080&seq=hero-v3-bg-2026&orientation=landscape"
          alt="Vigorbuy Spreadsheet Directory - Modern lifestyle workspace"
          title="Vigorbuy Spreadsheet Directory"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-32 md:py-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">

            {/* Left Content */}
            <div className="lg:max-w-2xl">
              {/* Social Proof */}
              <div className="flex items-center gap-3 mb-8">
                <div className="flex -space-x-3">
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-full border-2 border-white/80 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20stylish%20young%20person%20with%20warm%20smile%2C%20clean%20soft%20grey%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20minimalist%20editorial%20style%2C%20terracotta%20tone%20top%2C%20high%20quality%20photography&width=80&height=80&seq=hero-avatar-v3-a1&orientation=squarish"
                      alt="User avatar 1"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-full border-2 border-white/80 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Portrait%20of%20fashionable%20young%20adult%20with%20confident%20smile%2C%20minimal%20soft%20grey%20backdrop%2C%20soft%20studio%20lighting%2C%20genuine%20friendly%20look%2C%20clean%20editorial%20style%2C%20olive%20green%20casual%20attire%2C%20modern%20professional%20headshot&width=80&height=80&seq=hero-avatar-v3-a2&orientation=squarish"
                      alt="User avatar 2"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-full border-2 border-white/80 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20professional%20headshot%20of%20trendy%20individual%20with%20warm%20authentic%20smile%2C%20clean%20soft%20grey%20background%2C%20natural%20soft%20lighting%2C%20approachable%20expression%2C%20minimalist%20aesthetic%2C%20warm%20rust%20orange%20outfit%2C%20editorial%20quality%20portrait&width=80&height=80&seq=hero-avatar-v3-a3&orientation=squarish"
                      alt="User avatar 3"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <span className="text-white/90 text-sm md:text-base font-medium">
                  Trusted by 50,000+ Smart Shoppers
                </span>
              </div>

              {/* Title */}
              <h1 className="text-white mb-6">
                <span className="block text-4xl md:text-6xl lg:text-7xl font-light font-heading italic leading-tight">
                  The Ultimate
                </span>
                <span className="block text-4xl md:text-6xl lg:text-7xl font-bold font-heading leading-tight mt-1">
                  Vigorbuy Spreadsheet Directory
                </span>
              </h1>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row items-start gap-4 mt-8">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Explore Spreadsheet
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-white group-hover:translate-x-1 transition-transform duration-200">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-8 py-4 rounded-full border-2 border-white/60 text-white font-semibold text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Buy It Now
                </a>
              </div>
            </div>

            {/* Right Text Block */}
            <div className="lg:max-w-md lg:pb-4">
              <p className="text-white/85 text-lg md:text-xl leading-relaxed font-light">
                Discover verified product links, QC tips, and weekly updated collections. Your trusted gateway to organized shopping with the <strong className="font-semibold text-white">best vigorbuy spreadsheet</strong> available.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-white/50 text-xs font-medium tracking-wider uppercase">Scroll</span>
        <div className="w-5 h-8 rounded-full border-2 border-white/30 flex items-start justify-center p-1">
          <div className="w-1.5 h-1.5 rounded-full bg-white/70 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}